import { connectFunctionsEmulator, getFunctions, httpsCallable } from "firebase/functions"
import { functions } from "./index"
import type { Video } from "pexels"
import type { TweetV2, TweetV2SingleResult, UserV1 } from "twitter-api-v2"
import { TikTokIntegrationData } from "./integrations"
import { Video as PexelVideo } from "pexels"
import { SuggestedPexelsFootage } from "../../hooks/useTweet"
import { TiktokUserResponse } from "../integrations/tiktok"
// connectFunctionsEmulator(functions, "localhost", 5001)
export const createVideoThumbManually = httpsCallable(functions, "createVideoThumbManually")

export const createTwitterVideo = httpsCallable(functions, "createTwitterVideo")

export const createPortalLink = httpsCallable(functions, "ext-firestore-stripe-payments-createPortalLink")

export const createTestVideos = httpsCallable(functions, "createTestVideos")
export const getTweet = httpsCallable<
    { tweet_id: string; includeFootage?: boolean },
    {
        tweet: TweetV2SingleResult
        footage: SuggestedPexelsFootage | null
    }
>(functions, "getTweet")
export const getSuggestedFootageForTweet = httpsCallable<{ tweet_text: string }, SuggestedPexelsFootage>(
    functions,
    "getSuggestedFootageForTweet"
)
export const searchStockFootage = httpsCallable<{ query: string }, Video[]>(functions, "searchPexels")
export const redeemInviteCode = httpsCallable<{ inviteCode: string; uid: string; isAppsumo?: boolean }, void>(
    functions,
    "redeemInviteCode"
)
export const redeemReferralCode = httpsCallable<{ referralCode: string }, void>(functions, "redeemReferralCode")
export const sendDailyStatsTest = httpsCallable(functions, "sendDailyStatsTest")
export const onPaymentCreatedManual = httpsCallable(functions, "onPaymentCreatedManual")
export const createApiKey = httpsCallable(functions, "createApiKey")

export const searchTwitterUsers = httpsCallable<{ query: string }, UserV1[]>(functions, "searchTwitterUsers")
export const getLatestUserTweets = httpsCallable<{ username: string }, TweetV2[]>(functions, "getLatestUserTweets")
export const getTiktokUser = httpsCallable<{}, { data: TiktokUserResponse }>(functions, "getTiktokUser")
// refreshes tiktok refresh token using the auth code. updates user.integrations.tiktok doc
export const refreshTiktokToken = httpsCallable<{ code: string }, TikTokIntegrationData>(
    functions,
    "refreshTiktokToken"
)
export const refreshTiktokAccessToken = httpsCallable<{}, string>(functions, "refreshTiktokAccessToken")

export const logTestEvent = httpsCallable(functions, "logTestEvent")
